module.exports = __webpack_public_path__ + "img/nawalny.691a624c.png";